export default __webpack_public_path__ + "components/weather-icon/static/nightthunderstorm-6a4d0a07b41da61f7de2c902fe04529c.webp";